module.exports = {
  title: 'Threads Holo Ticket',
  author: 'Enzo Manuel Mangano',
  date: '2025-01-14',
  slug: 'threads-holo-ticket',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
